import React, { memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Col } from "antd";

// containers
import CheckUserEmail from "containers/CheckUserEmail";

function EmailValidatedInput({
  data,
  index,
  method,
  // default
  className,
}) {
  const childClassNames = classNames(
    "custom-form-column",
    "email-validated-column",
    className,
  );

  return (
    data && (
      <Col
        key={data?.name + index + "-col"}
        md={data?.col || 24}
        xs={24}
        offset={data?.offset || null}
        className={childClassNames}
      >
        <CheckUserEmail
          item={data}
          method={method}
          className="custom-form-field email-validated-input"
        />
      </Col>
    )
  );
}

EmailValidatedInput.defaultProps = {
  method: "new",
  index: 1,
};

EmailValidatedInput.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
};

export default memo(EmailValidatedInput);
